import "./styles.css";
import { renderAdmin } from "./views/admin";
import { renderRegistration } from "./views/registration";

const app = document.querySelector<HTMLDivElement>("#app");

if (!app) {
  throw new Error("Brak elementu aplikacji.");
}

if (window.location.pathname === "/admin" || window.location.pathname.startsWith("/admin/")) {
  void renderAdmin(app);
} else {
  renderRegistration(app);
}

if (window.location.pathname.startsWith("/admin") && "serviceWorker" in navigator) {
  void navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).then(() => {
    // Browsers decide whether persistence can be granted; no background-sync dependency.
    void navigator.storage?.persist?.().catch(() => false);
  }).catch(() => {
    const status = document.querySelector("#offline-status");
    if (status) status.textContent = "Nie udało się przygotować aplikacji offline. Pozostań online i odśwież panel.";
  });
}
